.formFieldContainer {
    flex: 1;
    margin: 0px 10px 10px 10px;
}

.list {
    color: var(--hps-blue);
    padding-left: 32px;
}

.checkboxContainer {
    display: flex;
    align-items: center;
    margin-left: -10px;
}

.stepLabelContainer {
    display: flex;
    align-items: center;
    gap: 20px;
}

.completeButtonContainer {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}

.existingUseCases {
    margin: 20px 0px;
}

.submitSelectionsContainer {
    margin-top: 20px;
    margin-bottom: 40px;
}

.submitIrqSelections {
    padding-top: 20px;
}